/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Summary_Memory_All_OneInputs */



/**
* | output |
* | --- |
* | "For that colleague, Wundo helps you prepare and keeps track of what you've discussed." |
*
* @param {Team_Summary_Memory_All_OneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_memory_all_one = /** @type {((inputs?: Team_Summary_Memory_All_OneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_Memory_All_OneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bij die collega helpt Wundo je bij de voorbereiding en houdt het de rode draad bij.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour ce collègue, Wundo vous aide à préparer et garde le fil de vos échanges.")
	return /** @type {LocalizedString} */ ("For that colleague, Wundo helps you prepare and keeps track of what you've discussed.")
});